import { combineReducers } from 'redux';
import { app, AppState } from 'src/store/reducers/app-reducer';
import { AppActions } from 'src/store/constants';
import { FormStateMap, reducer as form } from 'redux-form';
import { connectRouter, RouterState } from 'connected-react-router';
import history from 'src/navigation/history';
import { auth, AuthState } from './auth-reducer';
import { INotificationState, notifications } from './notification-reducer';
import { ProviderState, providers } from './provider-reducer';
import { EmailsLogState, emailsLog } from './email-log-reducer';
import { ServiceTypeState, serviceTypes } from './serviceType-reducer';
import { DistrictState, districts } from './district-reducer';
import { VendorState, vendors } from './vendor-reducer';
import { ServiceLocationState, serviceLocations } from './serviceLocation-reducer';
import { StudentState, students } from './student-reducer';
import { OrderState, orders } from './order-reducer';
import { CaseState, cases } from './case-reducer';
import { SeanceState, seances } from './seance-reducer';
import { SeanceListState, seancesList } from './seanceList-reducer';
import { SubstitutionState, substitutions } from './substitution-reducer';
import { InvoiceState, invoices } from './invoice-reducer';
import { ContractState, contracts } from './contract-reducer';
import { PaymentState, payments } from './payment-reducer';
import { CreditState, credits } from './credit-reducer';
import { AdminWorkState, adminWorks } from './adminWork-reducer';
import { ProgramBookDownloadState, programBookDownloads } from './programBookDownload-reducer';
import { BonusState, bonuses } from './bonus-reducer';
import { IntakeSentState, intakeSents } from './intakeSent-reducer';
import { ExpenseState, expenses } from './expense-reducer';
import { InternalState, internals } from './internal-reducer';
import { PayrollState, payrolls } from './payroll-reducer';
import { IncentiveState, incentives } from './incentive-reducer';
import { DeductionState, deductions } from './deduction-reducer';
import { CaseNoConsentState, casesNoConsent } from './caseNoConsent-reducer';
import { ReportPayrollState, reportPayrolls } from './reportPayroll-reducer';
import { ProviderReportState, providerReports } from './providerReport-reducer';
import { SeanceReportState, seanceReports } from './seanceReport-reducer';
import { OrderExpiredReportState, orderExpiredReports } from './orderExpiredReport-reducer';
import { OrderRemainingHoursReportState, orderRemainingHoursReports } from './orderRemainingHoursReport-reducer';
import { WorkedHoursReportState, workedHoursReports } from './workedHoursReport-reducer';
import { NonBilledSessionsReportState, nonBilledSessionsReport } from './nonBilledSessionsReport-reducer';
import { WageState, wages } from './wage-reducer';
import { InvoiceChangeState, invoiceChanges } from './invoiceChange-reducer';
import { ProgramBookState, programBooks } from './programBook-reducer';
import { programBookAnswers, ProgramBookAnswersState } from './programBookAnswers-reducer';
import { CaseNoPrincipalState, casesNoPrincipal } from './caseNoPrincipal-reducer';
import { IntakeMedicalReleaseState, intakeMedicalReleases } from './intakeMedicalRelease-reducer';

export interface StoreState {
    app: AppState;
    auth: AuthState;
    form: FormStateMap;
    wages: WageState;
    programBooks: ProgramBookState;
    programBookAnswers: ProgramBookAnswersState;
    invoiceChanges: InvoiceChangeState;
    expenses: ExpenseState;
    orderRemainingHoursReports: OrderRemainingHoursReportState;
    orderExpiredReports: OrderExpiredReportState;
    providerReports: ProviderReportState;
    seanceReports: SeanceReportState;
    workedHoursReports: WorkedHoursReportState;
    nonBilledSessionsReport: NonBilledSessionsReportState;
    router: RouterState;
    credits: CreditState;
    internals: InternalState;
    payments: PaymentState;
    casesNoConsent: CaseNoConsentState;
    casesNoPrincipal: CaseNoPrincipalState;
    notifications: INotificationState;
    providers: ProviderState;
    emailsLog: EmailsLogState;
    serviceTypes: ServiceTypeState;
    serviceLocations: ServiceLocationState;
    districts: DistrictState;
    vendors: VendorState;
    deductions: DeductionState;
    adminWorks: AdminWorkState;
    programBookDownloads: ProgramBookDownloadState;
    bonuses: BonusState;
    students: StudentState;
    orders: OrderState;
    cases: CaseState;
    invoices: InvoiceState;
    contracts: ContractState;
    seances: SeanceState;
    seancesList: SeanceListState;
    substitutions: SubstitutionState;
    payrolls: PayrollState;
    incentives: IncentiveState;
    reportPayrolls: ReportPayrollState;
    intakeSents: IntakeSentState;
    intakeMedicalReleases: IntakeMedicalReleaseState;
}

const appReducer = combineReducers<StoreState>({
    app,
    auth,
    reportPayrolls,
    invoiceChanges,
    casesNoConsent,
    casesNoPrincipal,
    providerReports,
    seanceReports,
    wages,
    programBooks,
    programBookAnswers,
    orderRemainingHoursReports,
    workedHoursReports,
    nonBilledSessionsReport,
    invoices,
    contracts,
    payrolls,
    incentives,
    orderExpiredReports,
    internals,
    providers,
    deductions,
    expenses,
    adminWorks,
    programBookDownloads,
    bonuses,
    serviceTypes,
    payments,
    credits,
    emailsLog,
    substitutions,
    districts,
    vendors,
    students,
    orders,
    cases,
    seances,
    seancesList,
    serviceLocations,
    notifications,
    intakeSents,
    intakeMedicalReleases,
    form,
    router: connectRouter(history),
});

export const rootReducer = (state: any, action: any): StoreState => {
    if (action.type === AppActions.APP_RESET) {
        state = undefined;
    }

    return appReducer(state, action);
};
